import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetForm, onGetOne, onSave } from 'redux/actions/jewishness.actions';
import {
  jewishnessFormSelector,
  jewishnessCementeriesSelector,
  jewishnessCivilStatesSelector,
  jewishnessFilesSelector,
  jewishnessIdCardTypesSelector,
  jewishnessTribesSelector,
} from 'redux/selectors/jewishness.selector';

import LayoutContainer from 'containers/LayoutContainer';
import JewishnessForm from 'views/public/JewishnessView/components/JewishnessForm';
import Loading from 'components/commons/Loading';

import { IJewishnessFormData } from 'views/public/JewishnessView/components/JewishnessForm/types';

import 'views/public/JewishnessView/components/JewishnessForm/i18n';

const JewishnessFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(jewishnessFormSelector);
  const { loading } = useTypedSelector((state) => state.jewishness);
  const cementeries = useTypedSelector(jewishnessCementeriesSelector);
  const civilStates = useTypedSelector(jewishnessCivilStatesSelector);
  const idCardTypes = useTypedSelector(jewishnessIdCardTypesSelector);
  const tribes = useTypedSelector(jewishnessTribesSelector);
  const files = useTypedSelector(jewishnessFilesSelector);
  const isEditing = !!id;

  useEffect(() => {
    dispatch(onGetForm());
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: IJewishnessFormData) => dispatch(onSave(formData, id));

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <JewishnessForm
        cementeries={cementeries}
        civilStates={civilStates}
        files={files}
        idCardTypes={idCardTypes}
        initialValues={initialValues}
        isEditing={isEditing}
        onSubmit={onSubmit}
        tribes={tribes}
      />
      {loading && <Loading isModalMode message={i18next.t('JEWISHNESS_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default JewishnessFormContainer;
